import React, { useState, useEffect, useMemo } from 'react';
import {
  Container,
  Paper,
  Typography,
  Box,
  AppBar,
  Toolbar,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Chip,
  Button,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Collapse,
  Divider,
  Avatar,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Select,
  FormControl,
  InputLabel,
  Alert,
  Snackbar,
  Tooltip,
  TextField,
  InputAdornment,
  Switch,
  FormControlLabel,
  Stack,
  Card,
  CardContent,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  People,
  School,
  Settings as SettingsIcon,
  Logout,
  Visibility,
  CheckCircle,
  Cancel,
  Pending,
  Person,
  Assignment,
  Download,
  Print,
  Refresh as RefreshIcon,
  Search,
  Add,
  Edit,
  Delete,
  CalendarToday,
  Grade as GradeIcon,
  Menu as MenuIcon,
  Assessment,
  Close as CloseIcon,
  Save,
  Lock,
  VpnKey,
  ContentCopy,
  PersonAdd,
  SupervisorAccount,
  ExpandLess,
  ExpandMore,
  DateRange,
  GroupAdd,
  LocalHospital,
  ContactPhone,
  LocationOn,
  BookmarkAdded,
  HowToReg,
} from '@mui/icons-material';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import api from '../services/api';

const DRAWER_WIDTH = 280;

const schoolColors = {
  primary: '#0d233a',     // Deep Navy (SUA-ESB style)
  primaryLight: '#1a365d',
  secondary: '#00796b',   // Teal Green Accent
  accent: '#e65100',      // Deep Orange
  gold: '#f59e0b',
  bgLight: '#f8fafc',
  cardBg: '#ffffff',
  textDark: '#0f172a',
  textMuted: '#64748b',
  border: '#e2e8f0',
  success: '#10b981',
  danger: '#ef4444',
  warning: '#f59e0b',
};

const AdminDashboard = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // Navigation / Tabs
  const [currentView, setCurrentView] = useState('overview'); 
  // 'overview', 'secondary', 'primary', 'window_settings', 'all_students', 'teachers', 'subjects', 'academic_years', 'reports', 'settings'
  const [mobileOpen, setMobileOpen] = useState(false);
  const [userMenuAnchor, setUserMenuAnchor] = useState(null);

  // Submenu Collapsible States
  const [openAdmissionsMenu, setOpenAdmissionsMenu] = useState(true);
  const [openStudentsMenu, setOpenStudentsMenu] = useState(true);
  const [openAcademicsMenu, setOpenAcademicsMenu] = useState(true);

  // Data states
  const [loading, setLoading] = useState(true);
  const [applications, setApplications] = useState([]);
  const [primaryStudents, setPrimaryStudents] = useState([]);
  const [academicYears, setAcademicYears] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [subjects, setSubjects] = useState([]);

  // Admission Window Settings State
  const [admissionWindow, setAdmissionWindow] = useState({
    window_open_date: '2026-01-01',
    window_close_date: '2026-12-31',
    is_open: 1,
    announcement_sw: 'Nafasi za masomo kwa mwaka wa masomo 2026/2027 zipo wazi kwa Kidato cha 1-6 na Shule ya Msingi & Awali English Medium.',
    announcement_en: 'Admissions for 2026/2027 academic session are currently open.',
    academic_year: '2026/2027'
  });
  const [isSavingWindow, setIsSavingWindow] = useState(false);

  // Bulk Admit
  const [bulkAdmitDialog, setBulkAdmitDialog] = useState(false);
  const [isBulkAdmitting, setIsBulkAdmitting] = useState(false);

  // Subject Modal
  const [subjectModal, setSubjectModal] = useState(false);
  const [newSubject, setNewSubject] = useState({ name: '', code: '', category: 'Core', form_level: 'Secondary' });

  // Promotion Modal
  const [promotionModal, setPromotionModal] = useState(false);
  const [promotionData, setPromotionData] = useState({ from_class: 'Form 1', to_class: 'Form 2' });
  const [isPromoting, setIsPromoting] = useState(false);

  // Details Modal (Full Profile: Parents, Medical, Academic)
  const [detailsModal, setDetailsModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [detailsType, setDetailsType] = useState('application'); // 'application' | 'student' | 'primary'

  // Statistics
  const [stats, setStats] = useState({
    totalSec: 0,
    approvedSec: 0,
    pendingSec: 0,
    rejectedSec: 0,
    totalPri: 0,
    dayPri: 0,
    boardingPri: 0,
    totalTeachers: 0,
  });

  // Filters & Search
  const [searchTerm, setSearchTerm] = useState('');
  const [filterLevel, setFilterLevel] = useState('all');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterGender, setFilterGender] = useState('all');

  // Pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Edit Modal & Forms
  const [editModal, setEditModal] = useState(false);
  const [editType, setEditType] = useState('secondary');
  const [editFormData, setEditFormData] = useState({});
  const [isSaving, setIsSaving] = useState(false);

  // Academic Year Modal
  const [yearModal, setYearModal] = useState(false);
  const [newYearInput, setNewYearInput] = useState('');
  const [newYearIsCurrent, setNewYearIsCurrent] = useState(false);

  // Change Password Modal
  const [passwordModal, setPasswordModal] = useState(false);
  const [passwordData, setPasswordData] = useState({ current_password: '', new_password: '', confirm_password: '' });
  const [passwordError, setPasswordError] = useState('');

  // Create Teacher Modal
  const [teacherModal, setTeacherModal] = useState(false);
  const [newTeacherData, setNewTeacherData] = useState({
    full_name: '',
    username: '',
    password: 'teacher123',
    email: '',
    phone: '',
    assigned_subject: '',
    assigned_class: ''
  });
  const [createdTeacherCredentials, setCreatedTeacherCredentials] = useState(null);

  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  // Initial Data Load
  useEffect(() => {
    loadDashboardData();
    loadAdmissionSettings();
  }, []);

  const loadAdmissionSettings = async () => {
    try {
      const res = await api.get('/admission-settings');
      if (res.data) {
        setAdmissionWindow({
          window_open_date: res.data.window_open_date || '2026-01-01',
          window_close_date: res.data.window_close_date || '2026-12-31',
          is_open: res.data.is_open !== undefined ? Number(res.data.is_open) : 1,
          announcement_sw: res.data.announcement_sw || '',
          announcement_en: res.data.announcement_en || '',
          academic_year: res.data.academic_year || '2026/2027'
        });
      }
    } catch (e) {
      console.warn('Could not load admission settings:', e);
    }
  };

  const loadDashboardData = async () => {
    setLoading(true);
    try {
      // 1. Fetch applications
      try {
        const secRes = await api.get('/admin/applications');
        setApplications(Array.isArray(secRes.data) ? secRes.data : []);
      } catch (e) {
        console.warn('Could not load secondary apps:', e);
      }

      // 2. Fetch primary students
      try {
        const priRes = await api.get('/admin/students?school_type=Primary');
        setPrimaryStudents(Array.isArray(priRes.data) ? priRes.data : []);
      } catch (e) {
        console.warn('Could not load primary students:', e);
      }

      // 3. Fetch academic years
      try {
        const yrRes = await api.get('/academic-years');
        setAcademicYears(Array.isArray(yrRes.data) ? yrRes.data : []);
      } catch (e) {
        console.warn('Could not load academic years:', e);
      }

      // 4. Fetch teachers
      try {
        const teachRes = await api.get('/admin/teachers');
        setTeachers(Array.isArray(teachRes.data) ? teachRes.data : []);
      } catch (e) {
        console.warn('Could not load teachers:', e);
      }

      // 5. Fetch subjects
      try {
        const subRes = await api.get('/subjects');
        setSubjects(Array.isArray(subRes.data) ? subRes.data : []);
      } catch (e) {
        console.warn('Could not load subjects:', e);
      }

    } catch (err) {
      console.error('Dashboard data error:', err);
      setSnackbar({ open: true, message: 'Hitilafu wakati wa kupakia baadhi ya taarifa', severity: 'error' });
    } finally {
      setLoading(false);
    }
  };

  // Compute Statistics
  useEffect(() => {
    const totalSec = applications.length;
    const approvedSec = applications.filter(a => a.status === 'approved' || a.status === 'admitted').length;
    const pendingSec = applications.filter(a => a.status === 'pending').length;
    const rejectedSec = applications.filter(a => a.status === 'rejected').length;

    const totalPri = primaryStudents.length;
    const dayPri = primaryStudents.filter(p => (p.day_boarding || '').toLowerCase() === 'day').length;
    const boardingPri = primaryStudents.filter(p => (p.day_boarding || '').toLowerCase() === 'boarding').length;
    const totalTeachers = teachers.length;

    setStats({
      totalSec,
      approvedSec,
      pendingSec,
      rejectedSec,
      totalPri,
      dayPri,
      boardingPri,
      totalTeachers,
    });
  }, [applications, primaryStudents, teachers]);

  // Current active year
  const currentAcademicYear = useMemo(() => {
    const found = academicYears.find(y => y.is_current === true || y.is_current === 1 || y.is_current === '1');
    return found ? found.year : admissionWindow.academic_year || '2026/2027';
  }, [academicYears, admissionWindow]);

  // Filtered Secondary Applications
  const filteredSecondary = useMemo(() => {
    return applications.filter(app => {
      const name = `${app.first_name || ''} ${app.middle_name || ''} ${app.last_name || ''}`.toLowerCase();
      const matchesSearch =
        (app.registration_number || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        name.includes(searchTerm.toLowerCase()) ||
        (app.parent_phone || '').includes(searchTerm) ||
        (app.necta_number || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        (app.previous_school || '').toLowerCase().includes(searchTerm.toLowerCase());

      const classApplying = app.class_applying || app.applying_for_level || '';
      const matchesLevel = filterLevel === 'all' || classApplying.toLowerCase() === filterLevel.toLowerCase();
      const matchesStatus = filterStatus === 'all' || (app.status || '').toLowerCase() === filterStatus.toLowerCase();
      const matchesGender = filterGender === 'all' || app.gender === filterGender;

      return matchesSearch && matchesLevel && matchesStatus && matchesGender;
    });
  }, [applications, searchTerm, filterLevel, filterStatus, filterGender]);

  // Filtered Primary Students
  const filteredPrimary = useMemo(() => {
    return primaryStudents.filter(stu => {
      const name = `${stu.first_name || ''} ${stu.middle_name || ''} ${stu.last_name || ''}`.toLowerCase();
      const matchesSearch =
        (stu.registration_number || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        name.includes(searchTerm.toLowerCase()) ||
        (stu.parent_phone || '').includes(searchTerm);

      const matchesClass = filterLevel === 'all' || (stu.current_class || stu.class_level || '').toLowerCase() === filterLevel.toLowerCase();
      const matchesGender = filterGender === 'all' || stu.gender === filterGender;

      return matchesSearch && matchesClass && matchesGender;
    });
  }, [primaryStudents, searchTerm, filterLevel, filterGender]);

  // Handle Status Change
  const handleStatusChange = async (id, newStatus) => {
    try {
      await api.put(`/admin/applications/${id}`, { status: newStatus });
      setApplications(prev => prev.map(a => a.id === id ? { ...a, status: newStatus } : a));
      setSnackbar({ open: true, message: `Hali ya maombi imebadilishwa kuwa ${newStatus.toUpperCase()} kikamilifu!`, severity: 'success' });
      if (newStatus === 'approved' || newStatus === 'admitted') {
        loadDashboardData();
      }
    } catch (err) {
      console.error('Status update failed:', err);
      setSnackbar({ open: true, message: 'Hitilafu wakati wa kubadilisha status', severity: 'error' });
    }
  };

  // Bulk Admit All Pending Applications
  const handleBulkAdmitAll = async () => {
    setIsBulkAdmitting(true);
    try {
      const res = await api.post('/admin/applications/bulk-admit', {});
      setSnackbar({ open: true, message: res.data?.message || 'Wanafunzi wote wamekuwa admitted kikamilifu!', severity: 'success' });
      setBulkAdmitDialog(false);
      loadDashboardData();
    } catch (err) {
      setSnackbar({ open: true, message: err.response?.data?.error || 'Hitilafu wakati wa ku-admit wote', severity: 'error' });
    } finally {
      setIsBulkAdmitting(false);
    }
  };

  // Delete Application
  const handleDeleteApplication = async (id, name) => {
    if (!window.confirm(`Je, una uhakika unataka kufuta maombi ya "${name}"? Hatua hii haiwezi kurudishwa.`)) return;
    try {
      await api.delete(`/admin/applications/${id}`);
      setApplications(prev => prev.filter(a => a.id !== id));
      setSnackbar({ open: true, message: 'Maombi yamefutwa kikamilifu!', severity: 'success' });
    } catch (err) {
      setSnackbar({ open: true, message: 'Hitilafu wakati wa kufuta maombi', severity: 'error' });
    }
  };

  // Delete Student
  const handleDeleteStudent = async (id, name) => {
    if (!window.confirm(`Je, una uhakika unataka kumfuta mwanafunzi "${name}" pamoja na matokeo yake yote? Hatua hii haiwezi kurudishwa.`)) return;
    try {
      await api.delete(`/admin/students/${id}`);
      setPrimaryStudents(prev => prev.filter(s => s.id !== id));
      setSnackbar({ open: true, message: 'Mwanafunzi amefutwa kikamilifu kwenye mfumo!', severity: 'success' });
    } catch (err) {
      setSnackbar({ open: true, message: 'Hitilafu wakati wa kufuta mwanafunzi', severity: 'error' });
    }
  };

  // View Full Details (Open Modal)
  const handleOpenDetails = (item, type = 'application') => {
    setSelectedItem(item);
    setDetailsType(type);
    setDetailsModal(true);
  };

  // Open Edit Modal
  const handleOpenEdit = (item, type = 'secondary') => {
    setEditType(type);
    setEditFormData({
      id: item.id,
      first_name: item.first_name || '',
      middle_name: item.middle_name || '',
      last_name: item.last_name || '',
      gender: item.gender || 'Male',
      date_of_birth: item.date_of_birth ? item.date_of_birth.split('T')[0] : '',
      school_type: item.school_type || (type === 'secondary' ? 'Secondary' : 'Primary'),
      class_level: item.class_level || item.current_class || item.class_applying || 'Form 1',
      current_class: item.current_class || item.class_level || item.class_applying || 'Form 1',
      combination: item.combination || '',
      day_boarding: item.day_boarding || 'Boarding',
      parent_name: item.parent_name || '',
      parent_relationship: item.parent_relationship || 'Parent',
      parent_phone: item.parent_phone || '',
      parent_phone2: item.parent_phone2 || '',
      parent_email: item.parent_email || '',
      parent_occupation: item.parent_occupation || '',
      parent_address: item.parent_address || '',
      relative_name: item.relative_name || '',
      relative_phone: item.relative_phone || '',
      relative_address: item.relative_address || '',
      has_chronic_illness: item.has_chronic_illness || 'Hapana',
      allergies: item.allergies || '',
      physical_disability: item.physical_disability || '',
      blood_group: item.blood_group || '',
      doctor_name: item.doctor_name || '',
      doctor_phone: item.doctor_phone || '',
      emergency_contact_name: item.emergency_contact_name || '',
      emergency_contact_phone: item.emergency_contact_phone || '',
      special_medical_instructions: item.special_medical_instructions || '',
      status: item.status || 'active',
    });
    setEditModal(true);
  };

  // Save Student / Application Edit
  const handleSaveEdit = async () => {
    setIsSaving(true);
    try {
      await api.put(`/admin/students/${editFormData.id}`, editFormData);
      setSnackbar({ open: true, message: 'Taarifa zimesasishwa kikamilifu!', severity: 'success' });
      setEditModal(false);
      loadDashboardData();
    } catch (err) {
      console.error('Save error:', err);
      setSnackbar({ open: true, message: 'Hitilafu wakati wa kuhifadhi mabadiliko', severity: 'error' });
    } finally {
      setIsSaving(false);
    }
  };

  // Save Admission Window Settings
  const handleSaveAdmissionWindow = async () => {
    setIsSavingWindow(true);
    try {
      await api.post('/admin/admission-settings', admissionWindow);
      setSnackbar({ open: true, message: 'Tarehe na mipangilio ya dirisha la maombi vimehifadhiwa kikamilifu!', severity: 'success' });
    } catch (e) {
      setSnackbar({ open: true, message: 'Hitilafu wakati wa kuhifadhi dirisha la maombi', severity: 'error' });
    } finally {
      setIsSavingWindow(false);
    }
  };

  // Create Teacher
  const handleCreateTeacher = async () => {
    if (!newTeacherData.full_name.trim() || !newTeacherData.username.trim()) {
      setSnackbar({ open: true, message: 'Tafadhali jaza Jina Kamili na Username ya mwalimu', severity: 'error' });
      return;
    }

    try {
      const res = await api.post('/admin/teachers', newTeacherData);
      setCreatedTeacherCredentials({
        username: newTeacherData.username,
        password: newTeacherData.password,
        name: newTeacherData.full_name,
        subject: newTeacherData.assigned_subject,
        class: newTeacherData.assigned_class,
      });
      setTeacherModal(false);
      setNewTeacherData({
        full_name: '',
        username: '',
        password: 'teacher123',
        email: '',
        phone: '',
        assigned_subject: '',
        assigned_class: ''
      });
      loadDashboardData();
      setSnackbar({ open: true, message: 'Akaunti ya mwalimu imetengenezwa kikamilifu!', severity: 'success' });
    } catch (err) {
      setSnackbar({ open: true, message: err.response?.data?.error || 'Hitilafu wakati wa kutengeneza mwalimu', severity: 'error' });
    }
  };

  // Delete Teacher
  const handleDeleteTeacher = async (teacherId, teacherName) => {
    if (!window.confirm(`Je, una uhakika unataka kufuta akaunti ya mwalimu "${teacherName}"?`)) return;
    try {
      await api.delete(`/admin/teachers/${teacherId}`);
      setTeachers(prev => prev.filter(t => t.id !== teacherId));
      setSnackbar({ open: true, message: 'Mwalimu amefutwa kikamilifu!', severity: 'success' });
    } catch (err) {
      setSnackbar({ open: true, message: 'Hitilafu wakati wa kufuta mwalimu', severity: 'error' });
    }
  };

  // Add Subject
  const handleSaveSubject = async () => {
    if (!newSubject.name.trim() || !newSubject.code.trim()) {
      setSnackbar({ open: true, message: 'Jina la somo na Code vinahitajika', severity: 'error' });
      return;
    }
    try {
      await api.post('/subjects', newSubject);
      setSnackbar({ open: true, message: 'Somo limeongezwa kikamilifu!', severity: 'success' });
      setSubjectModal(false);
      setNewSubject({ name: '', code: '', category: 'Core', form_level: 'Secondary' });
      loadDashboardData();
    } catch (e) {
      setSnackbar({ open: true, message: e.response?.data?.error || 'Hitilafu wakati wa kuongeza somo', severity: 'error' });
    }
  };

  // Delete Subject
  const handleDeleteSubject = async (subId, subName) => {
    if (!window.confirm(`Je, una uhakika unataka kufuta somo la "${subName}"?`)) return;
    try {
      await api.delete(`/subjects/${subId}`);
      setSubjects(prev => prev.filter(s => s.id !== subId));
      setSnackbar({ open: true, message: 'Somo limefutwa kikamilifu', severity: 'success' });
    } catch (e) {
      setSnackbar({ open: true, message: 'Hitilafu wakati wa kufuta somo', severity: 'error' });
    }
  };

  // Class Promotion
  const handlePromoteClass = async () => {
    if (promotionData.from_class === promotionData.to_class) {
      setSnackbar({ open: true, message: 'Darasa unalohamishia lazima liwe tofauti na la sasa', severity: 'warning' });
      return;
    }
    setIsPromoting(true);
    try {
      const res = await api.post('/admin/students/promote', promotionData);
      setSnackbar({ open: true, message: res.data?.message || 'Darasa limepandishwa kikamilifu!', severity: 'success' });
      setPromotionModal(false);
      loadDashboardData();
    } catch (e) {
      setSnackbar({ open: true, message: e.response?.data?.error || 'Hitilafu wakati wa kupandisha darasa', severity: 'error' });
    } finally {
      setIsPromoting(false);
    }
  };

  // Add Academic Year
  const handleSaveAcademicYear = async () => {
    if (!newYearInput.trim()) return;
    try {
      await api.post('/academic-years', {
        year: newYearInput.trim(),
        is_current: newYearIsCurrent,
      });
      setSnackbar({ open: true, message: `Mwaka ${newYearInput} umehifadhiwa kikamilifu!`, severity: 'success' });
      setYearModal(false);
      setNewYearInput('');
      setNewYearIsCurrent(false);
      loadDashboardData();
    } catch (err) {
      setSnackbar({ open: true, message: 'Hitilafu wakati wa kuhifadhi mwaka', severity: 'error' });
    }
  };

  // Set Year Active
  const handleSetYearActive = async (yearId) => {
    try {
      await api.put(`/academic-years/${yearId}`, { is_current: true });
      setAcademicYears(prev => prev.map(y => ({ ...y, is_current: y.id === yearId })));
      setSnackbar({ open: true, message: 'Mwaka wa sasa umesasishwa kikamilifu!', severity: 'success' });
    } catch (err) {
      setSnackbar({ open: true, message: 'Hitilafu wakati wa kusasisha mwaka', severity: 'error' });
    }
  };

  // Export to Excel
  const handleExportExcel = (type) => {
    const dataToExport = type === 'secondary'
      ? applications.map(a => ({
          'Reg Number': a.registration_number,
          'Name': `${a.first_name} ${a.middle_name || ''} ${a.last_name}`.trim(),
          'Gender': a.gender,
          'Class / Form': a.class_applying || a.applying_for_level,
          'Status': a.status,
          'Parent Name': a.parent_name,
          'Parent Phone': a.parent_phone,
          'Previous School': a.previous_school,
          'NECTA Number': a.necta_number,
          'Chronic Illness': a.has_chronic_illness,
          'Allergies': a.allergies,
          'Submission Date': a.created_at,
        }))
      : primaryStudents.map(p => ({
          'Reg Number': p.registration_number,
          'Full Name': `${p.first_name} ${p.middle_name || ''} ${p.last_name}`.trim(),
          'Class': p.current_class || p.class_level,
          'Gender': p.gender,
          'Day/Boarding': p.day_boarding,
          'Parent Name': p.parent_name,
          'Parent Phone': p.parent_phone,
          'Status': p.status,
        }));

    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, type === 'secondary' ? 'Secondary_Admissions' : 'Primary_Students');
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(data, `kaozya_${type}_records_${new Date().toISOString().slice(0,10)}.xlsx`);
  };

  // Print PDF for Details Modal
  const handlePrintDetails = () => {
    window.print();
  };

  // Logout
  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/admin/login');
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: schoolColors.bgLight }}>

      {/* ── Top Header ── */}
      <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          bgcolor: schoolColors.primary,
          color: 'white',
          boxShadow: '0 2px 10px rgba(0,0,0,0.15)',
        }}
      >
        <Toolbar sx={{ justifyContent: 'space-between', px: { xs: 2, md: 3 } }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            {isMobile && (
              <IconButton color="inherit" edge="start" onClick={() => setMobileOpen(!mobileOpen)}>
                <MenuIcon />
              </IconButton>
            )}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <Avatar
                sx={{
                  bgcolor: schoolColors.accent,
                  color: 'white',
                  fontWeight: 900,
                  width: 38,
                  height: 38,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                }}
              >
                K
              </Avatar>
              <Box>
                <Typography variant="subtitle1" sx={{ fontWeight: 900, lineHeight: 1.1, letterSpacing: 0.5 }}>
                  KAOZYA SCHOOLS
                </Typography>
                <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.72rem' }}>
                  Unified Admission &amp; School Management System
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* Right Header Controls */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Chip
              label={`Session: ${currentAcademicYear}`}
              size="small"
              sx={{ bgcolor: 'rgba(255,255,255,0.15)', color: 'white', fontWeight: 700 }}
            />
            <Button
              variant="outlined"
              size="small"
              startIcon={<GradeIcon />}
              onClick={() => navigate('/marks-entry')}
              sx={{
                color: schoolColors.gold,
                borderColor: schoolColors.gold,
                fontWeight: 700,
                textTransform: 'none',
                display: { xs: 'none', sm: 'inline-flex' },
                '&:hover': { bgcolor: 'rgba(245,158,11,0.1)', borderColor: schoolColors.gold }
              }}
            >
              Marks Entry
            </Button>
            <IconButton color="inherit" onClick={(e) => setUserMenuAnchor(e.currentTarget)}>
              <Avatar sx={{ width: 34, height: 34, bgcolor: schoolColors.secondary, fontSize: '0.9rem', fontWeight: 800 }}>
                A
              </Avatar>
            </IconButton>
            <Menu anchorEl={userMenuAnchor} open={Boolean(userMenuAnchor)} onClose={() => setUserMenuAnchor(null)}>
              <MenuItem onClick={() => { setUserMenuAnchor(null); setPasswordModal(true); }}>
                <ListItemIcon><Lock fontSize="small" /></ListItemIcon>
                Badilisha Password
              </MenuItem>
              <Divider />
              <MenuItem onClick={handleLogout} sx={{ color: schoolColors.danger }}>
                <ListItemIcon><Logout fontSize="small" sx={{ color: schoolColors.danger }} /></ListItemIcon>
                Ondoka (Logout)
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>

      {/* ── Sidebar Navigation Drawer ── */}
      <Drawer
        variant={isMobile ? 'temporary' : 'permanent'}
        open={isMobile ? mobileOpen : true}
        onClose={() => setMobileOpen(false)}
        sx={{
          width: DRAWER_WIDTH,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: DRAWER_WIDTH,
            boxSizing: 'border-box',
            bgcolor: '#ffffff',
            borderRight: '1px solid #e2e8f0',
            pt: 8,
          },
        }}
      >
        <Box sx={{ overflow: 'auto', px: 1.5, py: 2 }}>

          <List component="nav" dense>
            {/* Dashboard Overview */}
            <ListItemButton
              selected={currentView === 'overview'}
              onClick={() => { setCurrentView('overview'); if (isMobile) setMobileOpen(false); }}
              sx={{ borderRadius: 2, mb: 0.5, '&.Mui-selected': { bgcolor: `${schoolColors.primary}12`, color: schoolColors.primary } }}
            >
              <ListItemIcon sx={{ color: currentView === 'overview' ? schoolColors.primary : schoolColors.textMuted }}>
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText primary="Dashibodi (Overview)" primaryTypographyProps={{ fontWeight: 700 }} />
            </ListItemButton>

            <Divider sx={{ my: 1 }} />

            {/* ADMISSIONS SECTION */}
            <ListItemButton onClick={() => setOpenAdmissionsMenu(!openAdmissionsMenu)} sx={{ borderRadius: 2 }}>
              <ListItemIcon sx={{ color: schoolColors.primary }}><Assignment /></ListItemIcon>
              <ListItemText primary="Maombi ya Kujiunga" primaryTypographyProps={{ fontWeight: 800, fontSize: '0.88rem' }} />
              {openAdmissionsMenu ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={openAdmissionsMenu} timeout="auto" unmountOnExit>
              <List component="div" disablePadding sx={{ pl: 2 }}>
                <ListItemButton
                  selected={currentView === 'secondary'}
                  onClick={() => { setCurrentView('secondary'); if (isMobile) setMobileOpen(false); }}
                  sx={{ borderRadius: 2, mb: 0.5 }}
                >
                  <ListItemIcon sx={{ minWidth: 32 }}><School fontSize="small" /></ListItemIcon>
                  <ListItemText primary="Sekondari (Form 1-6)" primaryTypographyProps={{ fontSize: '0.84rem', fontWeight: 600 }} />
                </ListItemButton>
                <ListItemButton
                  selected={currentView === 'primary'}
                  onClick={() => { setCurrentView('primary'); if (isMobile) setMobileOpen(false); }}
                  sx={{ borderRadius: 2, mb: 0.5 }}
                >
                  <ListItemIcon sx={{ minWidth: 32 }}><People fontSize="small" /></ListItemIcon>
                  <ListItemText primary="English Medium (Msingi)" primaryTypographyProps={{ fontSize: '0.84rem', fontWeight: 600 }} />
                </ListItemButton>
                <ListItemButton
                  selected={currentView === 'window_settings'}
                  onClick={() => { setCurrentView('window_settings'); if (isMobile) setMobileOpen(false); }}
                  sx={{ borderRadius: 2, mb: 0.5 }}
                >
                  <ListItemIcon sx={{ minWidth: 32 }}><DateRange fontSize="small" color="primary" /></ListItemIcon>
                  <ListItemText primary="Dirisha la Maombi (Tarehe)" primaryTypographyProps={{ fontSize: '0.84rem', fontWeight: 700, color: schoolColors.accent }} />
                </ListItemButton>
              </List>
            </Collapse>

            <Divider sx={{ my: 1 }} />

            {/* STUDENTS SECTION */}
            <ListItemButton onClick={() => setOpenStudentsMenu(!openStudentsMenu)} sx={{ borderRadius: 2 }}>
              <ListItemIcon sx={{ color: schoolColors.secondary }}><School /></ListItemIcon>
              <ListItemText primary="Wanafunzi & Madarasa" primaryTypographyProps={{ fontWeight: 800, fontSize: '0.88rem' }} />
              {openStudentsMenu ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={openStudentsMenu} timeout="auto" unmountOnExit>
              <List component="div" disablePadding sx={{ pl: 2 }}>
                <ListItemButton
                  selected={currentView === 'all_students'}
                  onClick={() => { setCurrentView('all_students'); if (isMobile) setMobileOpen(false); }}
                  sx={{ borderRadius: 2, mb: 0.5 }}
                >
                  <ListItemIcon sx={{ minWidth: 32 }}><People fontSize="small" /></ListItemIcon>
                  <ListItemText primary="Orodha ya Wanafunzi Wote" primaryTypographyProps={{ fontSize: '0.84rem', fontWeight: 600 }} />
                </ListItemButton>
                <ListItemButton
                  onClick={() => setPromotionModal(true)}
                  sx={{ borderRadius: 2, mb: 0.5 }}
                >
                  <ListItemIcon sx={{ minWidth: 32 }}><HowToReg fontSize="small" sx={{ color: schoolColors.accent }} /></ListItemIcon>
                  <ListItemText primary="Kupandisha Madarasa" primaryTypographyProps={{ fontSize: '0.84rem', fontWeight: 700, color: schoolColors.accent }} />
                </ListItemButton>
              </List>
            </Collapse>

            <Divider sx={{ my: 1 }} />

            {/* ACADEMICS SECTION */}
            <ListItemButton onClick={() => setOpenAcademicsMenu(!openAcademicsMenu)} sx={{ borderRadius: 2 }}>
              <ListItemIcon sx={{ color: schoolColors.gold }}><GradeIcon /></ListItemIcon>
              <ListItemText primary="Masomo & Mitihani" primaryTypographyProps={{ fontWeight: 800, fontSize: '0.88rem' }} />
              {openAcademicsMenu ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={openAcademicsMenu} timeout="auto" unmountOnExit>
              <List component="div" disablePadding sx={{ pl: 2 }}>
                <ListItemButton
                  selected={currentView === 'subjects'}
                  onClick={() => { setCurrentView('subjects'); if (isMobile) setMobileOpen(false); }}
                  sx={{ borderRadius: 2, mb: 0.5 }}
                >
                  <ListItemIcon sx={{ minWidth: 32 }}><Assignment fontSize="small" /></ListItemIcon>
                  <ListItemText primary="Usimamizi wa Masomo" primaryTypographyProps={{ fontSize: '0.84rem', fontWeight: 600 }} />
                </ListItemButton>
                <ListItemButton
                  selected={currentView === 'academic_years'}
                  onClick={() => { setCurrentView('academic_years'); if (isMobile) setMobileOpen(false); }}
                  sx={{ borderRadius: 2, mb: 0.5 }}
                >
                  <ListItemIcon sx={{ minWidth: 32 }}><CalendarToday fontSize="small" /></ListItemIcon>
                  <ListItemText primary="Miaka ya Masomo" primaryTypographyProps={{ fontSize: '0.84rem', fontWeight: 600 }} />
                </ListItemButton>
                <ListItemButton
                  onClick={() => navigate('/marks-entry')}
                  sx={{ borderRadius: 2, mb: 0.5 }}
                >
                  <ListItemIcon sx={{ minWidth: 32 }}><GradeIcon fontSize="small" color="primary" /></ListItemIcon>
                  <ListItemText primary="Kuingiza Matokeo & Excel" primaryTypographyProps={{ fontSize: '0.84rem', fontWeight: 700, color: schoolColors.primary }} />
                </ListItemButton>
              </List>
            </Collapse>

            <Divider sx={{ my: 1 }} />

            {/* TEACHERS SECTION */}
            <ListItemButton
              selected={currentView === 'teachers'}
              onClick={() => { setCurrentView('teachers'); if (isMobile) setMobileOpen(false); }}
              sx={{ borderRadius: 2, mb: 0.5 }}
            >
              <ListItemIcon sx={{ color: schoolColors.secondary }}><SupervisorAccount /></ListItemIcon>
              <ListItemText primary="Akaunti za Walimu" primaryTypographyProps={{ fontWeight: 700, fontSize: '0.88rem' }} />
            </ListItemButton>

            {/* REPORTS */}
            <ListItemButton
              selected={currentView === 'reports'}
              onClick={() => { setCurrentView('reports'); if (isMobile) setMobileOpen(false); }}
              sx={{ borderRadius: 2, mb: 0.5 }}
            >
              <ListItemIcon sx={{ color: schoolColors.primary }}><Assessment /></ListItemIcon>
              <ListItemText primary="Ripoti & Takwimu" primaryTypographyProps={{ fontWeight: 700, fontSize: '0.88rem' }} />
            </ListItemButton>

            {/* SETTINGS */}
            <ListItemButton
              selected={currentView === 'settings'}
              onClick={() => { setCurrentView('settings'); if (isMobile) setMobileOpen(false); }}
              sx={{ borderRadius: 2, mb: 0.5 }}
            >
              <ListItemIcon sx={{ color: schoolColors.textMuted }}><SettingsIcon /></ListItemIcon>
              <ListItemText primary="Mipangilio & Benki" primaryTypographyProps={{ fontWeight: 700, fontSize: '0.88rem' }} />
            </ListItemButton>

          </List>
        </Box>
      </Drawer>

      {/* ── Main View Content ── */}
      <Box component="main" sx={{ flexGrow: 1, p: { xs: 2, sm: 3, md: 4 }, mt: 8, width: { sm: `calc(100% - ${DRAWER_WIDTH}px)` } }}>
        <Container maxWidth="xl" disableGutters>

          {/* ════════════════════════════════════════════════════════════════════
              1. OVERVIEW DASHBOARD VIEW
          ════════════════════════════════════════════════════════════════════ */}
          {currentView === 'overview' && (
            <motion.div initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3 }}>
              
              {/* Header Title & Actions */}
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, flexWrap: 'wrap', gap: 2 }}>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 900, color: schoolColors.textDark }}>
                    Dashibodi ya Utawala (Admin Dashboard)
                  </Typography>
                  <Typography variant="body2" sx={{ color: schoolColors.textMuted }}>
                    Mwaka wa Masomo: <strong>{currentAcademicYear}</strong> | Hali ya Dirisha: <strong>{admissionWindow.is_open ? 'Liko Wazi' : 'Limefungwa'}</strong>
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
                  <Button
                    variant="contained"
                    startIcon={<HowToReg />}
                    onClick={() => setBulkAdmitDialog(true)}
                    sx={{ bgcolor: schoolColors.accent, borderRadius: 2, fontWeight: 700, textTransform: 'none' }}
                  >
                    Admit Wote Pamoja (Bulk Admit)
                  </Button>
                  <Button
                    variant="contained"
                    startIcon={<PersonAdd />}
                    onClick={() => setTeacherModal(true)}
                    sx={{ bgcolor: schoolColors.secondary, borderRadius: 2, fontWeight: 700, textTransform: 'none' }}
                  >
                    Ongeza Mwalimu
                  </Button>
                  <Button
                    variant="outlined"
                    startIcon={<DateRange />}
                    onClick={() => setCurrentView('window_settings')}
                    sx={{ borderRadius: 2, fontWeight: 700, textTransform: 'none' }}
                  >
                    Dirisha la Maombi
                  </Button>
                </Box>
              </Box>

              {/* Admission Window Alert Banner */}
              <Alert
                severity={admissionWindow.is_open ? 'success' : 'warning'}
                sx={{ mb: 3, borderRadius: 3, fontWeight: 600, alignItems: 'center' }}
                action={
                  <Button color="inherit" size="small" onClick={() => setCurrentView('window_settings')} sx={{ fontWeight: 800 }}>
                    Badilisha Tarehe &rarr;
                  </Button>
                }
              >
                <strong>Dirisha la Maombi {admissionWindow.academic_year}:</strong> Tarehe ya Kuanza: <u>{admissionWindow.window_open_date}</u> | Tarehe ya Kufunga: <u>{admissionWindow.window_close_date}</u> ({admissionWindow.is_open ? 'LIKO WAZI' : 'LIMEFUNGWA'})
              </Alert>

              {/* KPI Metric Cards */}
              <Grid container spacing={2.5} sx={{ mb: 4 }}>
                {/* Secondary Total */}
                <Grid item xs={12} sm={6} md={3}>
                  <Paper sx={{ p: 2.5, borderRadius: 3, borderLeft: `5px solid ${schoolColors.primary}`, boxShadow: '0 4px 20px rgba(0,0,0,0.04)' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography variant="body2" sx={{ fontWeight: 700, color: schoolColors.textMuted }}>
                        Maombi ya Sekondari
                      </Typography>
                      <Avatar sx={{ bgcolor: `${schoolColors.primary}15`, color: schoolColors.primary, width: 40, height: 40 }}>
                        <School />
                      </Avatar>
                    </Box>
                    <Typography variant="h3" sx={{ fontWeight: 900, color: schoolColors.textDark, my: 1 }}>
                      {stats.totalSec}
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                      <Chip label={`Admitted/Approved: ${stats.approvedSec}`} size="small" sx={{ bgcolor: '#dcfce7', color: '#166534', fontWeight: 700, height: 22 }} />
                      <Chip label={`Pending: ${stats.pendingSec}`} size="small" sx={{ bgcolor: '#fef3c7', color: '#92400e', fontWeight: 700, height: 22 }} />
                    </Box>
                  </Paper>
                </Grid>

                {/* Primary Total */}
                <Grid item xs={12} sm={6} md={3}>
                  <Paper sx={{ p: 2.5, borderRadius: 3, borderLeft: `5px solid ${schoolColors.secondary}`, boxShadow: '0 4px 20px rgba(0,0,0,0.04)' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography variant="body2" sx={{ fontWeight: 700, color: schoolColors.textMuted }}>
                        Wanafunzi wa Msingi & Awali
                      </Typography>
                      <Avatar sx={{ bgcolor: `${schoolColors.secondary}15`, color: schoolColors.secondary, width: 40, height: 40 }}>
                        <People />
                      </Avatar>
                    </Box>
                    <Typography variant="h3" sx={{ fontWeight: 900, color: schoolColors.textDark, my: 1 }}>
                      {stats.totalPri}
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                      <Chip label={`Kutwa: ${stats.dayPri}`} size="small" sx={{ bgcolor: '#e0f2fe', color: '#0369a1', fontWeight: 700, height: 22 }} />
                      <Chip label={`Bweni: ${stats.boardingPri}`} size="small" sx={{ bgcolor: '#f3e8ff', color: '#6b21a8', fontWeight: 700, height: 22 }} />
                    </Box>
                  </Paper>
                </Grid>

                {/* Teachers Total */}
                <Grid item xs={12} sm={6} md={3}>
                  <Paper sx={{ p: 2.5, borderRadius: 3, borderLeft: `5px solid ${schoolColors.accent}`, boxShadow: '0 4px 20px rgba(0,0,0,0.04)' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography variant="body2" sx={{ fontWeight: 700, color: schoolColors.textMuted }}>
                        Walimu Waliosajiliwa
                      </Typography>
                      <Avatar sx={{ bgcolor: `${schoolColors.accent}15`, color: schoolColors.accent, width: 40, height: 40 }}>
                        <SupervisorAccount />
                      </Avatar>
                    </Box>
                    <Typography variant="h3" sx={{ fontWeight: 900, color: schoolColors.textDark, my: 1 }}>
                      {stats.totalTeachers}
                    </Typography>
                    <Button
                      size="small"
                      onClick={() => setCurrentView('teachers')}
                      sx={{ textTransform: 'none', fontWeight: 700, p: 0 }}
                    >
                      Simamia Walimu &rarr;
                    </Button>
                  </Paper>
                </Grid>

                {/* Academic Year */}
                <Grid item xs={12} sm={6} md={3}>
                  <Paper sx={{ p: 2.5, borderRadius: 3, borderLeft: `5px solid ${schoolColors.gold}`, boxShadow: '0 4px 20px rgba(0,0,0,0.04)' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography variant="body2" sx={{ fontWeight: 700, color: schoolColors.textMuted }}>
                        Mwaka wa Masomo
                      </Typography>
                      <Avatar sx={{ bgcolor: `${schoolColors.gold}20`, color: '#b45309', width: 40, height: 40 }}>
                        <CalendarToday />
                      </Avatar>
                    </Box>
                    <Typography variant="h3" sx={{ fontWeight: 900, color: schoolColors.textDark, my: 1 }}>
                      {currentAcademicYear}
                    </Typography>
                    <Chip label="ACTIVE SESSION" size="small" sx={{ bgcolor: '#dcfce7', color: '#166534', fontWeight: 800, height: 22 }} />
                  </Paper>
                </Grid>
              </Grid>

              {/* Recent Admissions Table */}
              <Paper sx={{ p: 3, borderRadius: 3, boxShadow: '0 4px 20px rgba(0,0,0,0.04)', mb: 4 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2.5 }}>
                  <Typography variant="h6" sx={{ fontWeight: 800, color: schoolColors.textDark }}>
                    Maombi Mapya ya Hivi Karibuni
                  </Typography>
                  <Button
                    size="small"
                    onClick={() => setCurrentView('secondary')}
                    sx={{ fontWeight: 700, textTransform: 'none' }}
                  >
                    Tazama Yote &rarr;
                  </Button>
                </Box>
                <TableContainer>
                  <Table size="small">
                    <TableHead sx={{ bgcolor: '#f8fafc' }}>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 800 }}>Reg Number</TableCell>
                        <TableCell sx={{ fontWeight: 800 }}>Jina la Mwanafunzi</TableCell>
                        <TableCell sx={{ fontWeight: 800 }}>Darasa / Kidato</TableCell>
                        <TableCell sx={{ fontWeight: 800 }}>Mzazi / Simu</TableCell>
                        <TableCell sx={{ fontWeight: 800 }}>Status</TableCell>
                        <TableCell sx={{ fontWeight: 800 }} align="center">Vitendo</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {applications.slice(0, 8).map((row) => (
                        <TableRow key={row.id} hover>
                          <TableCell sx={{ fontWeight: 700, fontFamily: 'monospace' }}>{row.registration_number}</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>{`${row.first_name} ${row.middle_name || ''} ${row.last_name}`.trim()}</TableCell>
                          <TableCell><Chip size="small" label={row.class_applying || row.applying_for_level} /></TableCell>
                          <TableCell>{row.parent_phone || '—'}</TableCell>
                          <TableCell>
                            <Chip
                              size="small"
                              label={row.status}
                              sx={{
                                fontWeight: 700,
                                bgcolor: (row.status === 'approved' || row.status === 'admitted') ? '#dcfce7' : row.status === 'rejected' ? '#fee2e2' : '#fef3c7',
                                color: (row.status === 'approved' || row.status === 'admitted') ? '#166534' : row.status === 'rejected' ? '#991b1b' : '#92400e',
                              }}
                            />
                          </TableCell>
                          <TableCell align="center">
                            <Tooltip title="Tazama Taarifa Zote (Wazazi, Magonjwa)">
                              <IconButton size="small" color="primary" onClick={() => handleOpenDetails(row, 'application')}>
                                <Visibility fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Badili Taarifa (Edit)">
                              <IconButton size="small" color="info" onClick={() => handleOpenEdit(row, 'secondary')}>
                                <Edit fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Futa">
                              <IconButton size="small" color="error" onClick={() => handleDeleteApplication(row.id, `${row.first_name} ${row.last_name}`)}>
                                <Delete fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            </motion.div>
          )}

          {/* ════════════════════════════════════════════════════════════════════
              2. SECONDARY ADMISSIONS MANAGEMENT VIEW
          ════════════════════════════════════════════════════════════════════ */}
          {currentView === 'secondary' && (
            <motion.div initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, flexWrap: 'wrap', gap: 2 }}>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 800, color: schoolColors.textDark }}>
                    Maombi ya Kujiunga Sekondari (Kidato cha 1 - 6 & Pre-Form 1)
                  </Typography>
                  <Typography variant="body2" sx={{ color: schoolColors.textMuted }}>
                    Kagua taarifa zote za wanafunzi, wazazi, magonjwa, badilisha status, na admit kwa pamoja.
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
                  <Button
                    variant="contained"
                    startIcon={<HowToReg />}
                    onClick={() => setBulkAdmitDialog(true)}
                    sx={{ bgcolor: schoolColors.accent, borderRadius: 2, fontWeight: 700, textTransform: 'none' }}
                  >
                    Admit Wote Pamoja ({applications.filter(a => a.status === 'pending').length} Pending)
                  </Button>
                  <Button
                    variant="outlined"
                    startIcon={<Download />}
                    onClick={() => handleExportExcel('secondary')}
                    sx={{ borderRadius: 2, fontWeight: 700, textTransform: 'none' }}
                  >
                    Pakua Excel
                  </Button>
                </Box>
              </Box>

              {/* Filters Bar */}
              <Paper sx={{ p: 2.5, borderRadius: 3, mb: 3, boxShadow: '0 4px 20px rgba(0,0,0,0.04)' }}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      size="small"
                      placeholder="Tafuta kwa jina, reg no, simu, namba ya necta..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      InputProps={{
                        startAdornment: <InputAdornment position="start"><Search fontSize="small" /></InputAdornment>,
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} sm={2.5}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Darasa / Kidato</InputLabel>
                      <Select value={filterLevel} label="Darasa / Kidato" onChange={(e) => setFilterLevel(e.target.value)}>
                        <MenuItem value="all">Madarasa Yote</MenuItem>
                        <MenuItem value="Form 1">Form 1</MenuItem>
                        <MenuItem value="Form 2">Form 2</MenuItem>
                        <MenuItem value="Form 3">Form 3</MenuItem>
                        <MenuItem value="Form 4">Form 4</MenuItem>
                        <MenuItem value="Form 5">Form 5</MenuItem>
                        <MenuItem value="Form 6">Form 6</MenuItem>
                        <MenuItem value="Pre-Form 1">Pre-Form 1</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6} sm={2.5}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Status</InputLabel>
                      <Select value={filterStatus} label="Status" onChange={(e) => setFilterStatus(e.target.value)}>
                        <MenuItem value="all">Status Zote</MenuItem>
                        <MenuItem value="admitted">Admitted</MenuItem>
                        <MenuItem value="approved">Approved</MenuItem>
                        <MenuItem value="pending">Pending</MenuItem>
                        <MenuItem value="rejected">Rejected</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Jinsia (Gender)</InputLabel>
                      <Select value={filterGender} label="Jinsia (Gender)" onChange={(e) => setFilterGender(e.target.value)}>
                        <MenuItem value="all">Jinsia Zote</MenuItem>
                        <MenuItem value="Male">Mvulana (Male)</MenuItem>
                        <MenuItem value="Female">Msichana (Female)</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Paper>

              {/* Applications Data Table */}
              <Paper sx={{ borderRadius: 3, overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.04)' }}>
                <TableContainer>
                  <Table>
                    <TableHead sx={{ bgcolor: schoolColors.primary }}>
                      <TableRow>
                        <TableCell sx={{ color: 'white', fontWeight: 700 }}>Registration #</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 700 }}>Jina Kamili</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 700 }}>Jinsia</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 700 }}>Kidato</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 700 }}>Mzazi &amp; Simu</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 700 }}>Hali (Status)</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 700 }} align="center">Vitendo</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredSecondary.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((app) => (
                        <TableRow key={app.id} hover>
                          <TableCell sx={{ fontWeight: 800, fontFamily: 'monospace', color: schoolColors.primary }}>
                            {app.registration_number}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 700 }}>
                            {`${app.first_name} ${app.middle_name || ''} ${app.last_name}`.trim()}
                          </TableCell>
                          <TableCell>
                            <Chip size="small" label={app.gender} />
                          </TableCell>
                          <TableCell>
                            <Chip size="small" label={app.class_applying || app.applying_for_level} sx={{ bgcolor: '#e0f2fe', color: '#0369a1', fontWeight: 700 }} />
                          </TableCell>
                          <TableCell>
                            <Typography variant="body2" sx={{ fontWeight: 600 }}>{app.parent_name || '—'}</Typography>
                            <Typography variant="caption" sx={{ color: schoolColors.textMuted }}>{app.parent_phone}</Typography>
                          </TableCell>
                          <TableCell>
                            <Select
                              size="small"
                              value={app.status || 'pending'}
                              onChange={(e) => handleStatusChange(app.id, e.target.value)}
                              sx={{
                                height: 30,
                                fontSize: '0.8rem',
                                fontWeight: 700,
                                borderRadius: 2,
                                bgcolor: (app.status === 'approved' || app.status === 'admitted') ? '#dcfce7' : app.status === 'rejected' ? '#fee2e2' : '#fef3c7',
                                color: (app.status === 'approved' || app.status === 'admitted') ? '#166534' : app.status === 'rejected' ? '#991b1b' : '#92400e',
                              }}
                            >
                              <MenuItem value="admitted">Admitted</MenuItem>
                              <MenuItem value="approved">Approved</MenuItem>
                              <MenuItem value="pending">Pending</MenuItem>
                              <MenuItem value="rejected">Rejected</MenuItem>
                            </Select>
                          </TableCell>
                          <TableCell align="center">
                            <Tooltip title="Tazama Taarifa Kamili (Wazazi, Afya, PDF)">
                              <IconButton size="small" color="primary" onClick={() => handleOpenDetails(app, 'application')}>
                                <Visibility fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Hariri Mwanafunzi (Edit)">
                              <IconButton size="small" color="info" onClick={() => handleOpenEdit(app, 'secondary')}>
                                <Edit fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Futa Mwanafunzi">
                              <IconButton size="small" color="error" onClick={() => handleDeleteApplication(app.id, `${app.first_name} ${app.last_name}`)}>
                                <Delete fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[10, 25, 50]}
                  component="div"
                  count={filteredSecondary.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={(e, p) => setPage(p)}
                  onRowsPerPageChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
                />
              </Paper>
            </motion.div>
          )}

          {/* ════════════════════════════════════════════════════════════════════
              3. ADMISSION WINDOW DATES SETTINGS VIEW
          ════════════════════════════════════════════════════════════════════ */}
          {currentView === 'window_settings' && (
            <motion.div initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3 }}>
              <Box sx={{ mb: 3 }}>
                <Typography variant="h4" sx={{ fontWeight: 800, color: schoolColors.textDark }}>
                  Mipangilio ya Dirisha la Maombi (Admission Window Dates)
                </Typography>
                <Typography variant="body2" sx={{ color: schoolColors.textMuted }}>
                  Weka tarehe rasmi ya kufungua na kufunga dirisha la maombi. Tarehe hizi na matangazo yataonekana kwenye Homepage na Dashibodi ya mfumo.
                </Typography>
              </Box>

              <Paper sx={{ p: 4, borderRadius: 3, maxWidth: 800, boxShadow: '0 4px 20px rgba(0,0,0,0.04)' }}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      type="date"
                      label="Tarehe ya Kufungua Dirisha (Opening Date)"
                      InputLabelProps={{ shrink: true }}
                      value={admissionWindow.window_open_date}
                      onChange={(e) => setAdmissionWindow({ ...admissionWindow, window_open_date: e.target.value })}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      type="date"
                      label="Tarehe ya Kufunga Dirisha (Closing Date)"
                      InputLabelProps={{ shrink: true }}
                      value={admissionWindow.window_close_date}
                      onChange={(e) => setAdmissionWindow({ ...admissionWindow, window_close_date: e.target.value })}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Mwaka wa Masomo (Academic Session)"
                      value={admissionWindow.academic_year}
                      onChange={(e) => setAdmissionWindow({ ...admissionWindow, academic_year: e.target.value })}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={admissionWindow.is_open === 1 || admissionWindow.is_open === true}
                          onChange={(e) => setAdmissionWindow({ ...admissionWindow, is_open: e.target.checked ? 1 : 0 })}
                          color="success"
                        />
                      }
                      label={
                        <Typography sx={{ fontWeight: 700, color: admissionWindow.is_open ? schoolColors.success : schoolColors.danger }}>
                          {admissionWindow.is_open ? 'DIRISHA LIKO WAZI (OPEN)' : 'DIRISHA LIMEFUNGWA (CLOSED)'}
                        </Typography>
                      }
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      multiline
                      rows={3}
                      label="Tangazo la Dirisha (Kiswahili)"
                      value={admissionWindow.announcement_sw}
                      onChange={(e) => setAdmissionWindow({ ...admissionWindow, announcement_sw: e.target.value })}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      multiline
                      rows={2}
                      label="Announcement (English)"
                      value={admissionWindow.announcement_en}
                      onChange={(e) => setAdmissionWindow({ ...admissionWindow, announcement_en: e.target.value })}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      size="large"
                      startIcon={<Save />}
                      onClick={handleSaveAdmissionWindow}
                      disabled={isSavingWindow}
                      sx={{ bgcolor: schoolColors.primary, fontWeight: 700, borderRadius: 2, px: 4, py: 1.5 }}
                    >
                      {isSavingWindow ? 'Inahifadhi...' : 'Hifadhi Mipangilio ya Dirisha'}
                    </Button>
                  </Grid>
                </Grid>
              </Paper>
            </motion.div>
          )}

          {/* ════════════════════════════════════════════════════════════════════
              4. PRIMARY & ENGLISH MEDIUM ADMISSIONS VIEW
          ════════════════════════════════════════════════════════════════════ */}
          {currentView === 'primary' && (
            <motion.div initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, flexWrap: 'wrap', gap: 2 }}>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 800, color: schoolColors.textDark }}>
                    Primary &amp; Pre-School (English Medium)
                  </Typography>
                  <Typography variant="body2" sx={{ color: schoolColors.textMuted }}>
                    Usajili wa wanafunzi wa Baby Class, Kindergarten, Pre-Unit na Darasa la 1 - 6.
                  </Typography>
                </Box>
                <Button
                  variant="outlined"
                  startIcon={<Download />}
                  onClick={() => handleExportExcel('primary')}
                  sx={{ borderRadius: 2, fontWeight: 700, textTransform: 'none' }}
                >
                  Pakua Excel
                </Button>
              </Box>

              {/* Primary Table */}
              <Paper sx={{ borderRadius: 3, overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.04)' }}>
                <TableContainer>
                  <Table>
                    <TableHead sx={{ bgcolor: schoolColors.secondary }}>
                      <TableRow>
                        <TableCell sx={{ color: 'white', fontWeight: 700 }}>Registration #</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 700 }}>Jina Kamili la Mwanafunzi</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 700 }}>Darasa (Class)</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 700 }}>Aina (Type)</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 700 }}>Mzazi &amp; Simu</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 700 }} align="center">Vitendo</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredPrimary.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((pupil) => (
                        <TableRow key={pupil.id} hover>
                          <TableCell sx={{ fontWeight: 800, fontFamily: 'monospace', color: schoolColors.secondary }}>
                            {pupil.registration_number}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 700 }}>{`${pupil.first_name} ${pupil.middle_name || ''} ${pupil.last_name}`.trim()}</TableCell>
                          <TableCell>
                            <Chip size="small" label={pupil.current_class || pupil.class_level} sx={{ bgcolor: '#dcfce7', color: '#166534', fontWeight: 700 }} />
                          </TableCell>
                          <TableCell>
                            <Chip
                              size="small"
                              label={pupil.day_boarding || 'Day'}
                              sx={{
                                bgcolor: pupil.day_boarding === 'Boarding' ? '#f3e8ff' : '#e0f2fe',
                                color: pupil.day_boarding === 'Boarding' ? '#6b21a8' : '#0369a1',
                                fontWeight: 700,
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            <Typography variant="body2" sx={{ fontWeight: 600 }}>{pupil.parent_name || '—'}</Typography>
                            <Typography variant="caption" sx={{ color: schoolColors.textMuted }}>{pupil.parent_phone}</Typography>
                          </TableCell>
                          <TableCell align="center">
                            <Tooltip title="Tazama Taarifa Zote">
                              <IconButton size="small" color="primary" onClick={() => handleOpenDetails(pupil, 'primary')}>
                                <Visibility fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Hariri (Edit)">
                              <IconButton size="small" color="info" onClick={() => handleOpenEdit(pupil, 'primary')}>
                                <Edit fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Futa">
                              <IconButton size="small" color="error" onClick={() => handleDeleteStudent(pupil.id, `${pupil.first_name} ${pupil.last_name}`)}>
                                <Delete fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            </motion.div>
          )}

          {/* ════════════════════════════════════════════════════════════════════
              5. ALL STUDENTS REGISTER VIEW
          ════════════════════════════════════════════════════════════════════ */}
          {currentView === 'all_students' && (
            <motion.div initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, flexWrap: 'wrap', gap: 2 }}>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 800, color: schoolColors.textDark }}>
                    Orodha Kuu ya Wanafunzi (All Students Register)
                  </Typography>
                  <Typography variant="body2" sx={{ color: schoolColors.textMuted }}>
                    Wanafunzi wote waliopo shuleni (Sekondari &amp; Msingi), kubadili madarasa na kupandisha madarasa.
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1.5 }}>
                  <Button
                    variant="contained"
                    startIcon={<School />}
                    onClick={() => setPromotionModal(true)}
                    sx={{ bgcolor: schoolColors.accent, borderRadius: 2, fontWeight: 700, textTransform: 'none' }}
                  >
                    Pandisha Darasa Zima (Class Promotion)
                  </Button>
                </Box>
              </Box>

              {/* Table combining all students */}
              <Paper sx={{ borderRadius: 3, overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.04)' }}>
                <TableContainer>
                  <Table>
                    <TableHead sx={{ bgcolor: schoolColors.primary }}>
                      <TableRow>
                        <TableCell sx={{ color: 'white', fontWeight: 700 }}>Registration #</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 700 }}>Jina Kamili</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 700 }}>Shule (Level)</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 700 }}>Darasa la Sasa</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 700 }}>Mzazi / Simu</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 700 }} align="center">Vitendo</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {applications.filter(a => a.status === 'admitted' || a.status === 'approved').concat(primaryStudents).map((s) => (
                        <TableRow key={s.id} hover>
                          <TableCell sx={{ fontWeight: 800, fontFamily: 'monospace', color: schoolColors.primary }}>
                            {s.registration_number}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 700 }}>
                            {`${s.first_name} ${s.middle_name || ''} ${s.last_name}`.trim()}
                          </TableCell>
                          <TableCell>
                            <Chip size="small" label={s.school_type || 'Secondary'} />
                          </TableCell>
                          <TableCell>
                            <Chip size="small" label={s.current_class || s.class_applying || s.class_level} sx={{ bgcolor: '#e0f2fe', color: '#0369a1', fontWeight: 700 }} />
                          </TableCell>
                          <TableCell>{s.parent_phone || '—'}</TableCell>
                          <TableCell align="center">
                            <Tooltip title="Tazama Taarifa Kamili">
                              <IconButton size="small" color="primary" onClick={() => handleOpenDetails(s, 'student')}>
                                <Visibility fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Hariri (Edit)">
                              <IconButton size="small" color="info" onClick={() => handleOpenEdit(s, s.school_type === 'Primary' ? 'primary' : 'secondary')}>
                                <Edit fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Futa">
                              <IconButton size="small" color="error" onClick={() => handleDeleteStudent(s.id, `${s.first_name} ${s.last_name}`)}>
                                <Delete fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            </motion.div>
          )}

          {/* ════════════════════════════════════════════════════════════════════
              6. TEACHERS MANAGEMENT VIEW
          ════════════════════════════════════════════════════════════════════ */}
          {currentView === 'teachers' && (
            <motion.div initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, flexWrap: 'wrap', gap: 2 }}>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 800, color: schoolColors.textDark }}>
                    Akaunti za Walimu wa Kuingiza Matokeo
                  </Typography>
                  <Typography variant="body2" sx={{ color: schoolColors.textMuted }}>
                    Tengeneza username na password kwa kila mwalimu. Kila mwalimu ataweza kuingia na kuingiza matokeo kwa njia ya moja kwa moja au kupakia faili la Excel kwa darasa zima.
                  </Typography>
                </Box>
                <Button
                  variant="contained"
                  startIcon={<PersonAdd />}
                  onClick={() => setTeacherModal(true)}
                  sx={{ bgcolor: schoolColors.secondary, borderRadius: 2, fontWeight: 700, textTransform: 'none' }}
                >
                  Ongeza Mwalimu Mpya
                </Button>
              </Box>

              {/* Teachers Table */}
              <Paper sx={{ borderRadius: 3, overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.04)' }}>
                <Table>
                  <TableHead sx={{ bgcolor: schoolColors.secondary }}>
                    <TableRow>
                      <TableCell sx={{ color: 'white', fontWeight: 700 }}>Jina la Mwalimu</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 700 }}>Username (Login)</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 700 }}>Somo Alilopangiwa</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 700 }}>Darasa</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 700 }}>Ruhusa</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 700 }} align="center">Vitendo</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {teachers.map((t) => (
                      <TableRow key={t.id} hover>
                        <TableCell sx={{ fontWeight: 700 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                            <Avatar sx={{ bgcolor: `${schoolColors.secondary}20`, color: schoolColors.secondary, fontWeight: 700, width: 34, height: 34 }}>
                              {t.full_name?.[0] || 'T'}
                            </Avatar>
                            {t.full_name}
                          </Box>
                        </TableCell>
                        <TableCell sx={{ fontWeight: 800, fontFamily: 'monospace', color: schoolColors.primary }}>
                          {t.username}
                        </TableCell>
                        <TableCell>{t.assigned_subject || 'Masomo Yote'}</TableCell>
                        <TableCell>{t.assigned_class || 'Madarasa Yote'}</TableCell>
                        <TableCell>
                          <Chip label="Kuingiza Matokeo" size="small" sx={{ bgcolor: '#e0f2fe', color: '#0369a1', fontWeight: 700 }} />
                        </TableCell>
                        <TableCell align="center">
                          <Tooltip title="Futa Mwalimu">
                            <IconButton size="small" color="error" onClick={() => handleDeleteTeacher(t.id, t.full_name)}>
                              <Delete fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                    {teachers.length === 0 && (
                      <TableRow>
                        <TableCell colSpan={6} align="center" sx={{ py: 6, color: schoolColors.textMuted }}>
                          Hakuna mwalimu aliyesajiliwa bado. Bonyeza "Ongeza Mwalimu Mpya" hapo juu.
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </Paper>
            </motion.div>
          )}

          {/* ════════════════════════════════════════════════════════════════════
              7. SUBJECTS MANAGEMENT VIEW
          ════════════════════════════════════════════════════════════════════ */}
          {currentView === 'subjects' && (
            <motion.div initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, flexWrap: 'wrap', gap: 2 }}>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 800, color: schoolColors.textDark }}>
                    Usimamizi wa Masomo (Subjects Management)
                  </Typography>
                  <Typography variant="body2" sx={{ color: schoolColors.textMuted }}>
                    Orodha ya masomo yote ya Sekondari na Shule ya Msingi yanayotumiwa na walimu kupakia matokeo.
                  </Typography>
                </Box>
                <Button
                  variant="contained"
                  startIcon={<Add />}
                  onClick={() => setSubjectModal(true)}
                  sx={{ bgcolor: schoolColors.primary, borderRadius: 2, fontWeight: 700, textTransform: 'none' }}
                >
                  Ongeza Somo Jipya
                </Button>
              </Box>

              <Paper sx={{ borderRadius: 3, overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.04)' }}>
                <Table>
                  <TableHead sx={{ bgcolor: schoolColors.primary }}>
                    <TableRow>
                      <TableCell sx={{ color: 'white', fontWeight: 700 }}>Code</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 700 }}>Jina la Somo (Subject Name)</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 700 }}>Aina (Category)</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 700 }}>Ngazi (Form Level)</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 700 }} align="center">Vitendo</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {subjects.map((sub) => (
                      <TableRow key={sub.id} hover>
                        <TableCell sx={{ fontWeight: 800, fontFamily: 'monospace', color: schoolColors.accent }}>
                          {sub.code}
                        </TableCell>
                        <TableCell sx={{ fontWeight: 700 }}>{sub.name}</TableCell>
                        <TableCell><Chip label={sub.category || 'Core'} size="small" /></TableCell>
                        <TableCell>{sub.form_level || 'Secondary'}</TableCell>
                        <TableCell align="center">
                          <Tooltip title="Futa Somo">
                            <IconButton size="small" color="error" onClick={() => handleDeleteSubject(sub.id, sub.name)}>
                              <Delete fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Paper>
            </motion.div>
          )}

          {/* ════════════════════════════════════════════════════════════════════
              8. ACADEMIC YEARS MANAGEMENT VIEW
          ════════════════════════════════════════════════════════════════════ */}
          {currentView === 'academic_years' && (
            <motion.div initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, flexWrap: 'wrap', gap: 2 }}>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 800, color: schoolColors.textDark }}>
                    Miaka ya Masomo (Academic Sessions)
                  </Typography>
                  <Typography variant="body2" sx={{ color: schoolColors.textMuted }}>
                    Ongeza mwaka wa masomo na weka mwaka wa sasa unaotumika na mfumo.
                  </Typography>
                </Box>
                <Button
                  variant="contained"
                  startIcon={<Add />}
                  onClick={() => setYearModal(true)}
                  sx={{ bgcolor: schoolColors.primary, borderRadius: 2, fontWeight: 700, textTransform: 'none' }}
                >
                  Ongeza Mwaka Mpya
                </Button>
              </Box>

              <Paper sx={{ borderRadius: 3, overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.04)' }}>
                <Table>
                  <TableHead sx={{ bgcolor: schoolColors.primary }}>
                    <TableRow>
                      <TableCell sx={{ color: 'white', fontWeight: 700 }}>Mwaka wa Masomo</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 700 }}>Hali (Status)</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 700 }} align="right">Kitendo</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {academicYears.map((yr) => (
                      <TableRow key={yr.id} hover>
                        <TableCell sx={{ fontWeight: 800, fontSize: '1.1rem' }}>
                          {yr.year}
                        </TableCell>
                        <TableCell>
                          {(yr.is_current === true || yr.is_current === 1 || yr.is_current === '1') ? (
                            <Chip label="CURRENT ACTIVE SESSION" sx={{ bgcolor: '#dcfce7', color: '#166534', fontWeight: 800 }} />
                          ) : (
                            <Chip label="Inactive" size="small" />
                          )}
                        </TableCell>
                        <TableCell align="right">
                          {!(yr.is_current === true || yr.is_current === 1 || yr.is_current === '1') && (
                            <Button
                              size="small"
                              variant="outlined"
                              onClick={() => handleSetYearActive(yr.id)}
                              sx={{ fontWeight: 700, textTransform: 'none', borderRadius: 2 }}
                            >
                              Weka Kuwa Mwaka wa Sasa
                            </Button>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Paper>
            </motion.div>
          )}

          {/* ════════════════════════════════════════════════════════════════════
              9. REPORTS & EXPORTS VIEW
          ════════════════════════════════════════════════════════════════════ */}
          {currentView === 'reports' && (
            <motion.div initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3 }}>
              <Typography variant="h4" sx={{ fontWeight: 800, color: schoolColors.textDark, mb: 1 }}>
                Ripoti na Takwimu za Wanafunzi
              </Typography>
              <Typography variant="body2" sx={{ color: schoolColors.textMuted, mb: 4 }}>
                Pakua orodha kamili ya wanafunzi, matokeo, na ripoti za utendaji kazi.
              </Typography>

              <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                  <Paper sx={{ p: 3, borderRadius: 3, border: '1px solid #e2e8f0', height: '100%' }}>
                    <School sx={{ fontSize: 40, color: schoolColors.primary, mb: 1.5 }} />
                    <Typography variant="h6" sx={{ fontWeight: 800, color: schoolColors.primary, mb: 1 }}>
                      Daftari la Sekondari (Form 1–6)
                    </Typography>
                    <Typography variant="body2" sx={{ color: schoolColors.textMuted, mb: 3 }}>
                      Orodha kamili ya wanafunzi wote wa sekondari, wazazi, na taarifa za afya.
                    </Typography>
                    <Button
                      variant="contained"
                      startIcon={<Download />}
                      onClick={() => handleExportExcel('secondary')}
                      sx={{ bgcolor: schoolColors.primary, borderRadius: 2, fontWeight: 700, textTransform: 'none' }}
                    >
                      Pakua Sekondari Excel (.xlsx)
                    </Button>
                  </Paper>
                </Grid>

                <Grid item xs={12} md={4}>
                  <Paper sx={{ p: 3, borderRadius: 3, border: '1px solid #e2e8f0', height: '100%' }}>
                    <People sx={{ fontSize: 40, color: schoolColors.secondary, mb: 1.5 }} />
                    <Typography variant="h6" sx={{ fontWeight: 800, color: schoolColors.secondary, mb: 1 }}>
                      Daftari la English Medium Primary
                    </Typography>
                    <Typography variant="body2" sx={{ color: schoolColors.textMuted, mb: 3 }}>
                      Orodha kamili ya wanafunzi wote wa shule ya awali na msingi na mawasiliano ya wazazi.
                    </Typography>
                    <Button
                      variant="contained"
                      startIcon={<Download />}
                      onClick={() => handleExportExcel('primary')}
                      sx={{ bgcolor: schoolColors.secondary, borderRadius: 2, fontWeight: 700, textTransform: 'none' }}
                    >
                      Pakua Msingi Excel (.xlsx)
                    </Button>
                  </Paper>
                </Grid>

                <Grid item xs={12} md={4}>
                  <Paper sx={{ p: 3, borderRadius: 3, border: '1px solid #e2e8f0', height: '100%' }}>
                    <GradeIcon sx={{ fontSize: 40, color: schoolColors.accent, mb: 1.5 }} />
                    <Typography variant="h6" sx={{ fontWeight: 800, color: schoolColors.accent, mb: 1 }}>
                      Ripoti na Matokeo ya Mitihani
                    </Typography>
                    <Typography variant="body2" sx={{ color: schoolColors.textMuted, mb: 3 }}>
                      Tazama matokeo ya mitihani yote (Midweek, Monthly, Mid-Term, Terminal, Mock) na nafasi za wanafunzi darasani.
                    </Typography>
                    <Button
                      variant="contained"
                      startIcon={<Assessment />}
                      onClick={() => navigate('/marks-entry')}
                      sx={{ bgcolor: schoolColors.accent, borderRadius: 2, fontWeight: 700, textTransform: 'none' }}
                    >
                      Tazama Matokeo &amp; Rankings
                    </Button>
                  </Paper>
                </Grid>
              </Grid>
            </motion.div>
          )}

          {/* ════════════════════════════════════════════════════════════════════
              10. SETTINGS VIEW
          ════════════════════════════════════════════════════════════════════ */}
          {currentView === 'settings' && (
            <motion.div initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3 }}>
              <Typography variant="h4" sx={{ fontWeight: 800, color: schoolColors.textDark, mb: 1 }}>
                Mipangilio ya Shule &amp; Akaunti za Benki
              </Typography>
              <Typography variant="body2" sx={{ color: schoolColors.textMuted, mb: 4 }}>
                Namba za usajili, namba za vituo vya NECTA, na akaunti rasmi za benki za kulipa ada.
              </Typography>

              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Paper sx={{ p: 3, borderRadius: 3, border: '1px solid #e2e8f0' }}>
                    <Typography variant="h6" sx={{ fontWeight: 800, color: schoolColors.primary, mb: 2 }}>
                      Taarifa za Sekondari &amp; High School
                    </Typography>
                    <Stack spacing={1.5}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>Namba ya Usajili:</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 700 }}>S.4913</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>Namba ya Kituo cha NECTA:</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 700 }}>S.5430</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>Akaunti ya CRDB Bank:</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 700, color: schoolColors.primary }}>0150270576600</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>Akaunti ya NMB Bank:</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 700, color: schoolColors.primary }}>24410021219</Typography>
                      </Box>
                    </Stack>
                  </Paper>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Paper sx={{ p: 3, borderRadius: 3, border: '1px solid #e2e8f0' }}>
                    <Typography variant="h6" sx={{ fontWeight: 800, color: schoolColors.secondary, mb: 2 }}>
                      Taarifa za English Medium Primary School
                    </Typography>
                    <Stack spacing={1.5}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>Namba ya Usajili:</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 700 }}>EM.21666</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>Namba ya Kituo cha Mtihani:</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 700 }}>PS11011193</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>Akaunti ya CRDB Bank:</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 700, color: schoolColors.secondary }}>10323210565</Typography>
                      </Box>
                    </Stack>
                  </Paper>
                </Grid>
              </Grid>
            </motion.div>
          )}

        </Container>
      </Box>

      {/* ══════════════════════════════════════════════════════════════════════
          BULK ADMIT CONFIRMATION DIALOG
      ══════════════════════════════════════════════════════════════════════ */}
      <Dialog open={bulkAdmitDialog} onClose={() => setBulkAdmitDialog(false)} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ bgcolor: schoolColors.accent, color: 'white', fontWeight: 800 }}>
          Admit Wanafunzi Wote Pamoja (Bulk Admit)
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          <Alert severity="info" sx={{ my: 1.5 }}>
            Hatua hii itawa-admit wanafunzi wote wenye maombi yaliyo "Pending" au "Approved" mara moja, na kuwapa namba rasmi za usajili na kuwahifadhi kwenye daftari la wanafunzi.
          </Alert>
          <Typography variant="body2" sx={{ fontWeight: 600, color: schoolColors.textDark }}>
            Je, una uhakika unataka kuendelea na kuwa-admit wanafunzi wote?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setBulkAdmitDialog(false)} color="inherit">Ghairi</Button>
          <Button
            variant="contained"
            onClick={handleBulkAdmitAll}
            disabled={isBulkAdmitting}
            sx={{ bgcolor: schoolColors.accent, fontWeight: 700 }}
          >
            {isBulkAdmitting ? 'Ina-admit...' : 'Ndio, Admit Wote Sasa'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ══════════════════════════════════════════════════════════════════════
          FULL DETAILS MODAL (Wazazi, Magonjwa, Afya, Elimu, PDF Print)
      ══════════════════════════════════════════════════════════════════════ */}
      <Dialog open={detailsModal} onClose={() => setDetailsModal(false)} maxWidth="md" fullWidth>
        <DialogTitle sx={{ bgcolor: schoolColors.primary, color: 'white', fontWeight: 800, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span>Fomu Kamili ya Mwanafunzi &amp; Maombi (Full Student Details)</span>
          <IconButton size="small" onClick={() => setDetailsModal(false)} sx={{ color: 'white' }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }} id="printable-details-area">
          {selectedItem && (
            <Box sx={{ p: 1 }}>
              {/* School Official Header in Details Modal */}
              <Box sx={{ textAlign: 'center', pb: 2, mb: 3, borderBottom: `2px solid ${schoolColors.primary}` }}>
                <Typography variant="h5" sx={{ fontWeight: 900, color: schoolColors.primary }}>
                  KAOZYA SCHOOLS (SECONDARY &amp; ENGLISH MEDIUM)
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 600, color: schoolColors.textMuted }}>
                  S.L.P 40 Mlimba, Morogoro, Tanzania | Simu: +255 765 892 000 / +255 784 455 600
                </Typography>
                <Typography variant="subtitle2" sx={{ fontWeight: 800, color: schoolColors.accent, mt: 0.5 }}>
                  TAARIFA ZA MWANAFUNZI NA FOMU YA USAJILI (OFFICIAL REGISTRATION PROFILE)
                </Typography>
              </Box>

              <Grid container spacing={2.5}>
                {/* 1. Student Personal Details */}
                <Grid item xs={12}>
                  <Paper sx={{ p: 2, bgcolor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 800, color: schoolColors.primary, mb: 1.5 }}>
                      1. TAARIFA ZA MWANAFUNZI (STUDENT PARTICULARS)
                    </Typography>
                    <Grid container spacing={1.5}>
                      <Grid item xs={12} sm={4}>
                        <Typography variant="caption" sx={{ color: schoolColors.textMuted }}>Namba ya Usajili (Reg No):</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 800, color: schoolColors.primary }}>{selectedItem.registration_number}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Typography variant="caption" sx={{ color: schoolColors.textMuted }}>Jina Kamili (Full Name):</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 700 }}>{`${selectedItem.first_name} ${selectedItem.middle_name || ''} ${selectedItem.last_name}`.trim()}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Typography variant="caption" sx={{ color: schoolColors.textMuted }}>Jinsia (Gender):</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>{selectedItem.gender}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Typography variant="caption" sx={{ color: schoolColors.textMuted }}>Tarehe ya Kuzaliwa (DOB):</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>{selectedItem.date_of_birth ? selectedItem.date_of_birth.split('T')[0] : '—'}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Typography variant="caption" sx={{ color: schoolColors.textMuted }}>Uraia &amp; Dini:</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>{selectedItem.nationality || 'Mtanzania'} | {selectedItem.religion || '—'}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Typography variant="caption" sx={{ color: schoolColors.textMuted }}>Darasa / Kidato Alichoomba:</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 800, color: schoolColors.accent }}>{selectedItem.class_applying || selectedItem.current_class || selectedItem.class_level}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Typography variant="caption" sx={{ color: schoolColors.textMuted }}>Aina ya Mwanafunzi:</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>{selectedItem.day_boarding || 'Bweni (Boarding)'}</Typography>
                      </Grid>
                      {selectedItem.combination && (
                        <Grid item xs={12} sm={4}>
                          <Typography variant="caption" sx={{ color: schoolColors.textMuted }}>Combination (A-Level):</Typography>
                          <Typography variant="body2" sx={{ fontWeight: 700, color: schoolColors.primary }}>{selectedItem.combination}</Typography>
                        </Grid>
                      )}
                    </Grid>
                  </Paper>
                </Grid>

                {/* 2. Previous School & NECTA Details */}
                <Grid item xs={12}>
                  <Paper sx={{ p: 2, bgcolor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 800, color: schoolColors.primary, mb: 1.5 }}>
                      2. TAARIFA ZA SHULE ALIYOTOKA &amp; NECTA (PREVIOUS ACADEMIC DETAILS)
                    </Typography>
                    <Grid container spacing={1.5}>
                      <Grid item xs={12} sm={4}>
                        <Typography variant="caption" sx={{ color: schoolColors.textMuted }}>Shule Aliyotoka:</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>{selectedItem.previous_school || selectedItem.primary_school || '—'}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Typography variant="caption" sx={{ color: schoolColors.textMuted }}>Namba ya Mtihani (NECTA / Index No):</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 700 }}>{selectedItem.necta_number || selectedItem.exam_number || '—'}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Typography variant="caption" sx={{ color: schoolColors.textMuted }}>Mwaka wa Kumaliza &amp; Daraja:</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>{selectedItem.completion_year || '—'} | {selectedItem.division || '—'}</Typography>
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid>

                {/* 3. Parent / Guardian Details */}
                <Grid item xs={12}>
                  <Paper sx={{ p: 2, bgcolor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 800, color: schoolColors.secondary, mb: 1.5 }}>
                      3. TAARIFA ZA WAZAZI NA WALEZI (PARENTS &amp; GUARDIANS)
                    </Typography>
                    <Grid container spacing={1.5}>
                      <Grid item xs={12} sm={4}>
                        <Typography variant="caption" sx={{ color: schoolColors.textMuted }}>Jina la Mzazi / Mlezi:</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 700 }}>{selectedItem.parent_name || selectedItem.father_name || '—'}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Typography variant="caption" sx={{ color: schoolColors.textMuted }}>Uhusiano:</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>{selectedItem.parent_relationship || 'Mzazi (Parent)'}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Typography variant="caption" sx={{ color: schoolColors.textMuted }}>Namba ya Simu 1:</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 700, color: schoolColors.primary }}>{selectedItem.parent_phone || selectedItem.father_phone || '—'}</Typography>
                      </Grid>
                      {selectedItem.parent_phone2 && (
                        <Grid item xs={12} sm={4}>
                          <Typography variant="caption" sx={{ color: schoolColors.textMuted }}>Namba ya Simu 2:</Typography>
                          <Typography variant="body2" sx={{ fontWeight: 600 }}>{selectedItem.parent_phone2}</Typography>
                        </Grid>
                      )}
                      <Grid item xs={12} sm={4}>
                        <Typography variant="caption" sx={{ color: schoolColors.textMuted }}>Barua Pepe (Email):</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>{selectedItem.parent_email || '—'}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Typography variant="caption" sx={{ color: schoolColors.textMuted }}>Kazi ya Mzazi:</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>{selectedItem.parent_occupation || '—'}</Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="caption" sx={{ color: schoolColors.textMuted }}>Makazi ya Mzazi (Anuani / Mtaa / Wilaya / Mkoa):</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>{selectedItem.parent_address || selectedItem.residential_street || '—'}</Typography>
                      </Grid>
                      {selectedItem.relative_name && (
                        <Grid item xs={12}>
                          <Divider sx={{ my: 1 }} />
                          <Typography variant="caption" sx={{ color: schoolColors.textMuted }}>Mtu wa Karibu / Ndugu mwingine:</Typography>
                          <Typography variant="body2" sx={{ fontWeight: 600 }}>{selectedItem.relative_name} ({selectedItem.relative_relationship || 'Ndugu'}) - Simu: {selectedItem.relative_phone || '—'}</Typography>
                        </Grid>
                      )}
                    </Grid>
                  </Paper>
                </Grid>

                {/* 4. Medical and Health Information */}
                <Grid item xs={12}>
                  <Paper sx={{ p: 2, bgcolor: '#fef2f2', borderRadius: 2, border: '1px solid #fee2e2' }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 800, color: schoolColors.danger, mb: 1.5 }}>
                      4. TAARIFA ZA AFYA NA MAGONJWA (MEDICAL PARTICULARS)
                    </Typography>
                    <Grid container spacing={1.5}>
                      <Grid item xs={12} sm={4}>
                        <Typography variant="caption" sx={{ color: schoolColors.textMuted }}>Magonjwa ya Kudumu (Chronic Illness):</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 700, color: selectedItem.has_chronic_illness === 'Ndio' ? schoolColors.danger : 'inherit' }}>
                          {selectedItem.has_chronic_illness || 'Hapana'}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Typography variant="caption" sx={{ color: schoolColors.textMuted }}>Mzio (Allergies):</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>{selectedItem.allergies || 'Hakuna'}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Typography variant="caption" sx={{ color: schoolColors.textMuted }}>Ulemavu / Mahitaji Maalum:</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>{selectedItem.physical_disability || 'Hakuna'}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Typography variant="caption" sx={{ color: schoolColors.textMuted }}>Kundi la Damu (Blood Group):</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 700 }}>{selectedItem.blood_group || '—'}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Typography variant="caption" sx={{ color: schoolColors.textMuted }}>Daktari wa Mwanafunzi &amp; Simu:</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>{selectedItem.doctor_name || '—'} {selectedItem.doctor_phone ? `(${selectedItem.doctor_phone})` : ''}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Typography variant="caption" sx={{ color: schoolColors.textMuted }}>Mawasiliano ya Dharura (Emergency Contact):</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 700, color: schoolColors.accent }}>
                          {selectedItem.emergency_contact_name || selectedItem.parent_name || '—'} ({selectedItem.emergency_contact_phone || selectedItem.parent_phone || '—'})
                        </Typography>
                      </Grid>
                      {selectedItem.special_medical_instructions && (
                        <Grid item xs={12}>
                          <Typography variant="caption" sx={{ color: schoolColors.textMuted }}>Maelekezo Maalum ya Dawa / Afya:</Typography>
                          <Typography variant="body2" sx={{ fontWeight: 600, color: schoolColors.danger }}>{selectedItem.special_medical_instructions}</Typography>
                        </Grid>
                      )}
                    </Grid>
                  </Paper>
                </Grid>

              </Grid>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2.5, borderTop: '1px solid #e2e8f0', justifyContent: 'space-between' }}>
          <Button
            variant="outlined"
            startIcon={<Print />}
            onClick={handlePrintDetails}
            sx={{ fontWeight: 700, textTransform: 'none' }}
          >
            Print / Save as PDF
          </Button>
          <Box sx={{ display: 'flex', gap: 1.5 }}>
            {selectedItem?.status === 'pending' && (
              <Button
                variant="contained"
                onClick={() => { handleStatusChange(selectedItem.id, 'admitted'); setDetailsModal(false); }}
                sx={{ bgcolor: schoolColors.success, fontWeight: 700 }}
              >
                Admit Sasa (Admit Student)
              </Button>
            )}
            <Button onClick={() => setDetailsModal(false)} color="inherit" sx={{ fontWeight: 700 }}>
              Funga
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      {/* ══════════════════════════════════════════════════════════════════════
          EDIT STUDENT / APPLICATION MODAL
      ══════════════════════════════════════════════════════════════════════ */}
      <Dialog open={editModal} onClose={() => setEditModal(false)} maxWidth="md" fullWidth>
        <DialogTitle sx={{ bgcolor: schoolColors.primary, color: 'white', fontWeight: 800 }}>
          Hariri Taarifa za Mwanafunzi (Edit Student Information)
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          <Grid container spacing={2} sx={{ mt: 0.5 }}>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Jina la Kwanza (First Name)"
                value={editFormData.first_name || ''}
                onChange={(e) => setEditFormData({ ...editFormData, first_name: e.target.value })}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Jina la Kati (Middle Name)"
                value={editFormData.middle_name || ''}
                onChange={(e) => setEditFormData({ ...editFormData, middle_name: e.target.value })}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Jina la Mwisho (Last Name)"
                value={editFormData.last_name || ''}
                onChange={(e) => setEditFormData({ ...editFormData, last_name: e.target.value })}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <InputLabel>Jinsia (Gender)</InputLabel>
                <Select
                  value={editFormData.gender || 'Male'}
                  label="Jinsia (Gender)"
                  onChange={(e) => setEditFormData({ ...editFormData, gender: e.target.value })}
                >
                  <MenuItem value="Male">Mvulana (Male)</MenuItem>
                  <MenuItem value="Female">Msichana (Female)</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                type="date"
                label="Tarehe ya Kuzaliwa"
                InputLabelProps={{ shrink: true }}
                value={editFormData.date_of_birth || ''}
                onChange={(e) => setEditFormData({ ...editFormData, date_of_birth: e.target.value })}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Darasa / Kidato (Class Level)"
                value={editFormData.current_class || editFormData.class_level || ''}
                onChange={(e) => setEditFormData({ ...editFormData, current_class: e.target.value, class_level: e.target.value })}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Jina la Mzazi / Mlezi"
                value={editFormData.parent_name || ''}
                onChange={(e) => setEditFormData({ ...editFormData, parent_name: e.target.value })}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Simu ya Mzazi"
                value={editFormData.parent_phone || ''}
                onChange={(e) => setEditFormData({ ...editFormData, parent_phone: e.target.value })}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Makazi / Anuani ya Mzazi"
                value={editFormData.parent_address || ''}
                onChange={(e) => setEditFormData({ ...editFormData, parent_address: e.target.value })}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Magonjwa ya Kudumu (Kama yapo)"
                value={editFormData.has_chronic_illness || ''}
                onChange={(e) => setEditFormData({ ...editFormData, has_chronic_illness: e.target.value })}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Mzio / Allergies"
                value={editFormData.allergies || ''}
                onChange={(e) => setEditFormData({ ...editFormData, allergies: e.target.value })}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 2.5, borderTop: '1px solid #e2e8f0' }}>
          <Button onClick={() => setEditModal(false)} color="inherit" sx={{ fontWeight: 700 }}>
            Ghairi
          </Button>
          <Button
            variant="contained"
            onClick={handleSaveEdit}
            disabled={isSaving}
            startIcon={<Save />}
            sx={{ bgcolor: schoolColors.primary, fontWeight: 700, borderRadius: 2 }}
          >
            {isSaving ? 'Inahifadhi...' : 'Hifadhi Mabadiliko'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ══════════════════════════════════════════════════════════════════════
          CREATE TEACHER MODAL
      ══════════════════════════════════════════════════════════════════════ */}
      <Dialog open={teacherModal} onClose={() => setTeacherModal(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ bgcolor: schoolColors.secondary, color: 'white', fontWeight: 800 }}>
          Sajili Akaunti ya Mwalimu (Kuingiza Matokeo)
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          <Alert severity="info" sx={{ mb: 2.5, mt: 1 }}>
            Mwalimu atatumia <strong>Username</strong> na <strong>Password</strong> hii kuingia kwenye mfumo wa kuingiza matokeo.
          </Alert>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Jina Kamili la Mwalimu (Full Name)"
                placeholder="mfano: Mwl. Juma Rashidi"
                value={newTeacherData.full_name}
                onChange={(e) => setNewTeacherData({ ...newTeacherData, full_name: e.target.value })}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Username (Login)"
                placeholder="mfano: juma.rashidi"
                value={newTeacherData.username}
                onChange={(e) => setNewTeacherData({ ...newTeacherData, username: e.target.value.toLowerCase().replace(/\s+/g, '.') })}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Password ya Mwalimu"
                value={newTeacherData.password}
                onChange={(e) => setNewTeacherData({ ...newTeacherData, password: e.target.value })}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Somo Alilopangiwa (Assigned Subject)"
                placeholder="mfano: Mathematics, English, Biology"
                value={newTeacherData.assigned_subject}
                onChange={(e) => setNewTeacherData({ ...newTeacherData, assigned_subject: e.target.value })}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Darasa Alilopangiwa (Assigned Class)"
                placeholder="mfano: Form 1, Form 2, Grade 1"
                value={newTeacherData.assigned_class}
                onChange={(e) => setNewTeacherData({ ...newTeacherData, assigned_class: e.target.value })}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Namba ya Simu au Email"
                value={newTeacherData.phone}
                onChange={(e) => setNewTeacherData({ ...newTeacherData, phone: e.target.value })}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 2.5 }}>
          <Button onClick={() => setTeacherModal(false)} color="inherit">Ghairi</Button>
          <Button
            variant="contained"
            onClick={handleCreateTeacher}
            sx={{ bgcolor: schoolColors.secondary, fontWeight: 700, borderRadius: 2 }}
          >
            Hifadhi Akaunti ya Mwalimu
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Add Subject Modal ── */}
      <Dialog open={subjectModal} onClose={() => setSubjectModal(false)} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ bgcolor: schoolColors.primary, color: 'white', fontWeight: 800 }}>
          Ongeza Somo Jipya (Add Subject)
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          <TextField
            fullWidth
            label="Jina la Somo (Subject Name)"
            placeholder="mfano: Computer Studies, Kiswahili"
            value={newSubject.name}
            onChange={(e) => setNewSubject({ ...newSubject, name: e.target.value })}
            sx={{ mt: 1, mb: 2 }}
          />
          <TextField
            fullWidth
            label="Kifupi / Code ya Somo (e.g. COMP, KISW)"
            value={newSubject.code}
            onChange={(e) => setNewSubject({ ...newSubject, code: e.target.value.toUpperCase() })}
            sx={{ mb: 2 }}
          />
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Aina ya Somo</InputLabel>
            <Select
              value={newSubject.category}
              label="Aina ya Somo"
              onChange={(e) => setNewSubject({ ...newSubject, category: e.target.value })}
            >
              <MenuItem value="Core">Core</MenuItem>
              <MenuItem value="Science">Science</MenuItem>
              <MenuItem value="Arts">Arts</MenuItem>
              <MenuItem value="Business">Business</MenuItem>
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <InputLabel>Ngazi ya Shule</InputLabel>
            <Select
              value={newSubject.form_level}
              label="Ngazi ya Shule"
              onChange={(e) => setNewSubject({ ...newSubject, form_level: e.target.value })}
            >
              <MenuItem value="Secondary">Sekondari (Secondary)</MenuItem>
              <MenuItem value="Primary">Msingi & Awali (Primary)</MenuItem>
              <MenuItem value="Advanced">High School (Form 5-6)</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setSubjectModal(false)} color="inherit">Ghairi</Button>
          <Button variant="contained" onClick={handleSaveSubject} sx={{ bgcolor: schoolColors.primary, fontWeight: 700 }}>
            Hifadhi Somo
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Class Promotion Modal ── */}
      <Dialog open={promotionModal} onClose={() => setPromotionModal(false)} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ bgcolor: schoolColors.accent, color: 'white', fontWeight: 800 }}>
          Kupandisha Madarasa (Class Promotion)
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          <Alert severity="info" sx={{ mb: 2.5, mt: 1 }}>
            Wanafunzi wote waliopo kwenye darasa la sasa watapandishwa kwenda darasa jipya ulilochagua.
          </Alert>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Darasa la Sasa (From Class)</InputLabel>
            <Select
              value={promotionData.from_class}
              label="Darasa la Sasa (From Class)"
              onChange={(e) => setPromotionData({ ...promotionData, from_class: e.target.value })}
            >
              <MenuItem value="Pre-Form 1">Pre-Form 1</MenuItem>
              <MenuItem value="Form 1">Form 1</MenuItem>
              <MenuItem value="Form 2">Form 2</MenuItem>
              <MenuItem value="Form 3">Form 3</MenuItem>
              <MenuItem value="Form 4">Form 4</MenuItem>
              <MenuItem value="Form 5">Form 5</MenuItem>
              <MenuItem value="Baby Class">Baby Class</MenuItem>
              <MenuItem value="Pre-Unit">Pre-Unit</MenuItem>
              <MenuItem value="Grade 1">Grade 1</MenuItem>
              <MenuItem value="Grade 2">Grade 2</MenuItem>
              <MenuItem value="Grade 3">Grade 3</MenuItem>
              <MenuItem value="Grade 4">Grade 4</MenuItem>
              <MenuItem value="Grade 5">Grade 5</MenuItem>
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <InputLabel>Darasa Wanapokwenda (To Class)</InputLabel>
            <Select
              value={promotionData.to_class}
              label="Darasa Wanapokwenda (To Class)"
              onChange={(e) => setPromotionData({ ...promotionData, to_class: e.target.value })}
            >
              <MenuItem value="Form 1">Form 1</MenuItem>
              <MenuItem value="Form 2">Form 2</MenuItem>
              <MenuItem value="Form 3">Form 3</MenuItem>
              <MenuItem value="Form 4">Form 4</MenuItem>
              <MenuItem value="Form 5">Form 5</MenuItem>
              <MenuItem value="Form 6">Form 6</MenuItem>
              <MenuItem value="Pre-Unit">Pre-Unit</MenuItem>
              <MenuItem value="Grade 1">Grade 1</MenuItem>
              <MenuItem value="Grade 2">Grade 2</MenuItem>
              <MenuItem value="Grade 3">Grade 3</MenuItem>
              <MenuItem value="Grade 4">Grade 4</MenuItem>
              <MenuItem value="Grade 5">Grade 5</MenuItem>
              <MenuItem value="Grade 6">Grade 6</MenuItem>
              <MenuItem value="Graduated">Graduated (Wamemaliza)</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setPromotionModal(false)} color="inherit">Ghairi</Button>
          <Button
            variant="contained"
            onClick={handlePromoteClass}
            disabled={isPromoting}
            sx={{ bgcolor: schoolColors.accent, fontWeight: 700 }}
          >
            {isPromoting ? 'Inapandisha...' : 'Thibitisha Upandishaji'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Add Academic Year Modal ── */}
      <Dialog open={yearModal} onClose={() => setYearModal(false)} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ bgcolor: schoolColors.primary, color: 'white', fontWeight: 800 }}>
          Ongeza Mwaka wa Masomo
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          <TextField
            fullWidth
            label="Mwaka wa Masomo (e.g. 2026/2027, 2027)"
            placeholder="2026/2027"
            value={newYearInput}
            onChange={(e) => setNewYearInput(e.target.value)}
            sx={{ mt: 1, mb: 2 }}
          />
          <FormControlLabel
            control={
              <Switch
                checked={newYearIsCurrent}
                onChange={(e) => setNewYearIsCurrent(e.target.checked)}
                color="primary"
              />
            }
            label="Weka kuwa Mwaka Rasmi wa Sasa (Current Active)"
          />
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setYearModal(false)} color="inherit">Ghairi</Button>
          <Button variant="contained" onClick={handleSaveAcademicYear} sx={{ bgcolor: schoolColors.primary, fontWeight: 700 }}>
            Hifadhi Mwaka
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Snackbar Notifications ── */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })}>
          {snackbar.message}
        </Alert>
      </Snackbar>

    </Box>
  );
};

export default AdminDashboard;
